import React from 'react';
import { inlineActionButtonTemplate } from '../theme';

function SavedParameterCard({ param, onQueue, onLoad, onDelete }) {
  // Get tickers
  const tickers = Array.isArray(param.tickers)
    ? param.tickers.join(', ')
    : param.tickers;
  const isCall = param.option_type === 'call';

  // Format strike position with ITM/ATM/OTM label
  const formatStrikePosition = () => {
    const pct = (param.strike_pct * 100).toFixed(0);
    const sign = param.strike_pct > 0 ? '+' : '';
    let moneyness = 'ATM';

    if (param.option_type === 'call') {
      if (param.strike_pct < -0.02) moneyness = 'ITM';
      else if (param.strike_pct > 0.02) moneyness = 'OTM';
    } else { // put
      if (param.strike_pct > 0.02) moneyness = 'ITM';
      else if (param.strike_pct < -0.02) moneyness = 'OTM';
    }

    return `${sign}${pct}% ${moneyness}`;
  };

  // Format expected move
  const formatExpectedMove = () => {
    const pct = (param.stock_gain_pct * 100).toFixed(0);
    const sign = param.stock_gain_pct > 0 ? '+' : '';
    return `${sign}${pct}%`;
  };

  return (
    <div className={`queue-card saved-param-card ${isCall ? 'call-card' : 'put-card'}`}>
      <div className="queue-card-header">
        <div className="queue-card-tickers">
          {tickers}
        </div>
        <div className="queue-card-header-actions">
          <span className={`option-type-badge ${isCall ? 'call' : 'put'}`}>
            {isCall ? 'CALL' : 'PUT'}
          </span>
        </div>
      </div>

      {/* 2x2 Parameter Grid matching queue cards */}
      <div className="queue-card-params-grid">
        <div className="param-item">
          <div className="param-label">EXPIRATION</div>
          <div className="param-value">{param.days_until_exp} days</div>
        </div>
        <div className="param-item">
          <div className="param-label">STRIKE</div>
          <div className="param-value">{formatStrikePosition()}</div>
        </div>
        <div className="param-item">
          <div className="param-label">DAYS TO TARGET</div>
          <div className="param-value">{param.days_to_gain} days</div>
        </div>
        <div className="param-item">
          <div className="param-label">UNDERLYING</div>
          <div className="param-value expected-move">{formatExpectedMove()}</div>
        </div>
      </div>

      {/* Label (if exists) */}
      {param.label && (
        <div className="saved-param-label">
          {param.label}
        </div>
      )}

      <div className="queue-card-actions">
        <button
          onClick={() => onQueue(param)}
          className={`${inlineActionButtonTemplate.cssClasses.base} ${inlineActionButtonTemplate.cssClasses.primary}`}
          title="Add to scenario queue"
        >
          Queue
        </button>
        <button
          onClick={() => onLoad(param)}
          className={`${inlineActionButtonTemplate.cssClasses.base} ${inlineActionButtonTemplate.cssClasses.primary}`}
          title="Load into form"
        >
          Load
        </button>
        <button
          onClick={() => onDelete(param.id)}
          className={`${inlineActionButtonTemplate.cssClasses.base} ${inlineActionButtonTemplate.cssClasses.danger}`}
          title="Delete saved parameter"
        >
          Delete
        </button>
      </div>
    </div>
  );
}

export default SavedParameterCard;